import { render, staticRenderFns } from "./ProofDetailsPage.vue?vue&type=template&id=e67b6cbc&scoped=true&"
import script from "./ProofDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProofDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProofDetailsPage.vue?vue&type=style&index=0&id=e67b6cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67b6cbc",
  null
  
)

export default component.exports